:host {
  border-color: inherit;
  display: table-row-group;
  vertical-align: middle;
}
